export default __webpack_public_path__ + "static/media/1.dfad93f4.png";